import { useEffect, useState } from 'react';

import { fetchInvestorProAmount } from 'services/depositService';

export const useFetchInvestorProAmount = () => {
  const [values, setValues] = useState({
    perUser: 0,
    allPackages: 0,
  });

  useEffect(() => {
    fetchInvestorProAmount().then((values) => {
      if (values.user_investor_sum && values.all_investor_sum)
        setValues({ allPackages: values.all_investor_sum, perUser: values.user_investor_sum });
    });
  }, []);

  return values;
};
